import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { IImageTemplateSummary, ImageTemplateStatus } from '../../../models/ImageTemplate';
import { useUserSession } from '../../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'admin/imageTemplates';

export function useAdminSocialImageTemplatesQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useUserSession();
	const status = ImageTemplateStatus.Published;
	return useQuery({
		enabled,
		// The route returns every template with the status in one page, so there is no page to follow.
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IPagedCollection<IImageTemplateSummary>>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: 'admin/imageTemplates', queryParams: { status } }),
				'GET'
			),
		queryKey: [BASE_QUERY_KEY, { status }],
		// Only decks linked to a social template reach customers, so the rest have no brand worth previewing.
		select: page =>
			(page?.values ?? []).filter(
				template => !!template.systemTemplateId && template.templateType === Api.TemplateType.SocialMediaPost
			),
		meta: {
			toastErrorMessage: "Couldn't load the social templates.",
			errorLogging: { category: 'ImageTemplate', action: 'AdminSocialImageTemplatesQuery-Error' },
		},
	});
}
